import React, { useEffect, useCallback, useState } from 'react';
import history from 'services/history';
import { useAuth } from 'context/AuthContext';

import { Modal, Container, BtnContainer, Button } from './style';

const CompleteProducerRegistration: React.FC = () => {

  const { participant, isProfileRegisterComplete } = useAuth();  
  const [isOpen, setIsOpen] = useState(false);

  const constructUrl = history.location.pathname + history.location.search;
  useEffect(() => {
      if (!participant || Object.keys(participant).length === 0) return;
      if (participant[ 'profile'] !== 'PRODUTOR') {
        setIsOpen(false); 
        return;
      }
      if (isProfileRegisterComplete) return;
  
      if(!isProfileRegisterComplete && constructUrl !== '/editar-perfil?pre_select=dados_de_cultivo' && constructUrl !== '/editar-perfil' ) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }    

  }, [participant, constructUrl, isProfileRegisterComplete]);

  const onConfirmHandler = useCallback(() => {
    history.push('/editar-perfil?pre_select=dados_de_cultivo');
  }, []);


  return (
    <>
      <Modal isOpen={isOpen} forceOpen={isOpen} type="primary">
        <Container>
            <h2>COMPLETE SEUS DADOS!</h2>
            <p>
                {
                    `Termine seu cadastro com as informações referentes à "Dados da
                     minha fazenda e/ou CNPJ*" e "Dados da área de cultivo",
                     encontradas nas abas 2 e 3, para enviar sua(s) nota(s)
                     fiscal(is).`
                }
            </p>
            <span>Atualize agora clicando no botão abaixo.</span>
        </Container>
        <BtnContainer>
          <Button type="button" onClick={onConfirmHandler}>
            PREENCHER DADOS
          </Button>
        </BtnContainer>
      </Modal>
    </>
  );
};

export default CompleteProducerRegistration;
